<div class="row">
  <!-- Display current date -->
  <div class="col-md-12">
    <div class="pull-right dateDisabled">
      <i class="fa-solid fa-calendar-days me-2"></i>
      <span>{{ time | date : "yyyy-MM-dd" : "UTC" }}</span>
    </div>
  </div>
</div>
<div class="dashboard-container">
  <ng-template #dashboardsContent>
    <div [innerHTML]="htmlContent | safeHtml"></div>
  </ng-template>

  <ng-container *ngTemplateOutlet="dashboardsContent"></ng-container>
</div>
